import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import { Card, IconButton, Menu, Text } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { Folder } from "../types";

interface FolderCardProps {
  folder: Folder;
  onPress: (folder: Folder) => void;
  onEdit: (folder: Folder) => void;
  onDelete: (folder: Folder) => void;
}

export default function FolderCard({
  folder,
  onPress,
  onEdit,
  onDelete,
}: FolderCardProps) {
  const [menuVisible, setMenuVisible] = useState(false);
  const { t } = useTranslation();

  const closeMenu = () => setMenuVisible(false);
  const hasFolderMeta = folder.fileCount > 0 || folder.size !== "0 MB";

  return (
    <Card style={styles.card} onPress={() => onPress(folder)}>
      <Card.Content>
        <View style={styles.header}>
          <IconButton
            icon={folder.icon}
            iconColor={folder.iconColor}
            size={32}
            onPress={() => onPress(folder)}
            style={[styles.icon, { backgroundColor: `${folder.iconColor}20` }]}
          />
          <Menu
            visible={menuVisible}
            onDismiss={closeMenu}
            anchor={
              <IconButton
                icon="dots-vertical"
                size={20}
                onPress={() => setMenuVisible(true)}
              />
            }
          >
            <Menu.Item
              onPress={() => {
                closeMenu();
                onEdit(folder);
              }}
              title={t("Edit")}
            />
            <Menu.Item
              onPress={() => {
                closeMenu();
                onDelete(folder);
              }}
              title={t("Delete")}
            />
          </Menu>
        </View>
        <Text variant="titleMedium" style={styles.name}>
          {folder.name}
        </Text>
        {hasFolderMeta && (
          <Text variant="bodySmall" style={styles.info}>
            {folder.fileCount} files - {folder.size}
          </Text>
        )}
      </Card.Content>
    </Card>
  );
}

const styles = StyleSheet.create({
  card: {
    width: "48%",
    minWidth: 150,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  icon: {
    margin: 0,
  },
  name: {
    fontWeight: "600",
    marginBottom: 4,
  },
  info: {
    opacity: 0.6,
  },
});
